export const queries = {
  shipping: {
    return: (tracking_number: string) => `/tracking/shippingitems/${tracking_number}/return/`,
    returnPhoto: (tracking_number: string) => `/tracking/shippingitems/${tracking_number}/return/photo/`,
    orders: (tracking_number: string) => `/tracking/shippingitems/${tracking_number}/orderitems/`,
    deliveryinfo: (tracking_number?: string) => `/tracking/shippingitems/${tracking_number}/deliveryinfo/`,
    info: (tracking_number: string) => `/tracking/shippingitems/${tracking_number}/info/`,
    history: (tracking_number: string) => `/shipping/shippingitems/${tracking_number}/history/`,
  },
  address: {
    info: (tracking_number: string) => `/tracking/shippingitems/${tracking_number}/address/deliveryinfo/`,
  }
}
